import { gql } from "@apollo/client";

export const INCREMENT_PROJECT_VIEWS = gql`
  mutation incrementRealEstateProjectViews($project_id: Int!) {
    RealEstateProjects {
      incrementViews(project_id: $project_id)
    }
  }
`;

export const INCREMENT_PROJECT_STATS = gql`
  mutation incrementRealEstateProjectStats(
    $project_id: Int!
    $stats_type: RealEstateProjectStatsTypeEnum!
  ) {
    RealEstateProjects {
      incrementStats(project_id: $project_id, stats_type: $stats_type)
    }
  }
`;

export const INIT_PAYMENT_REQUEST = gql`
  mutation initPaymentRequest($buyer_phone_number: String!, $listing_id: Int!) {
    RealEstateProjectOperations {
      initPaymentRequest(
        buyer_phone_number: $buyer_phone_number
        listing_id: $listing_id
      ) {
        request_id
        listing_id
        user_id
        amount
      }
    }
  }
`;
